import React from 'react'
import FormDescription from 'components/FormDescription'
import FormLinks from 'components/FormLinks'
import yup from 'yup'
import { Form, SecondaryLink } from 'stylist'
import { post } from 'utils/api'

const schema = yup.object().shape({
  email: yup
    .string()
    .email('Email must be a valid email address')
    .required("Email can't be blank")
})

const RouteLoginForgotPasswordIndex = ({ match: { path } }) => (
  <Form
    redirect={`${path}/confirmation`}
    validationSchema={schema}
    initialValues={{ email: '' }}
    onSubmit={({ email }) =>
      post('/users/password', {
        payload: { user: { email } }
      }).catch(() => Promise.reject('An error has occurred'))
    }
  >
    <Form.Title>Forgot password</Form.Title>
    <FormDescription>
      Please enter your email address below to reset your password.
    </FormDescription>
    <Form.Errors />
    <Form.Group>
      <label htmlFor="email">Email</label>
      <Form.Input id="email" name="email" type="email" />
    </Form.Group>
    <Form.Group buttons>
      <Form.SubmitButton block>Submit</Form.SubmitButton>
    </Form.Group>
    <FormLinks>
      <SecondaryLink to="/login">Sign in </SecondaryLink>
    </FormLinks>
  </Form>
)

export default RouteLoginForgotPasswordIndex



// WEBPACK FOOTER //
// ./src/routes/login/forgot-password/index.js